module.exports = __webpack_public_path__ + "static/dog-5f08c4c0ac84aa2a43ac5ed781bc88a4.mp3";